var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceGreenExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0L17.461 3.34817L22.229 2.67376L23.061 7.41681L27.3148 9.67376L25.2 14L27.3148 18.3262L23.061 20.5832L22.229 25.3262L17.461 24.6518L14 28L10.539 24.6518L5.77101 25.3262L4.93901 20.5832L0.685208 18.3262L2.8 14L0.685208 9.67376L4.93901 7.41681L5.77101 2.67376L10.539 3.34817L14 0Z",
    fill: "#00AA63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3728 15.171L12.9098 8.34647H15.6874L15.2245 15.171H13.3728ZM14.2986 18.9193C13.8805 18.9193 13.537 18.7849 13.2682 18.5161C12.9994 18.2473 12.865 17.9287 12.865 17.5603C12.865 17.182 12.9994 16.8684 13.2682 16.6195C13.537 16.3607 13.8805 16.2313 14.2986 16.2313C14.7267 16.2313 15.0702 16.3607 15.329 16.6195C15.5978 16.8684 15.7322 17.182 15.7322 17.5603C15.7322 17.9287 15.5978 18.2473 15.329 18.5161C15.0702 18.7849 14.7267 18.9193 14.2986 18.9193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceGreenExclamation);
export default __webpack_public_path__ + "static/media/insurance-green-exclamation.dd82a1b373b1cd491efba23526575332.svg";
export { ForwardRef as ReactComponent };